import { render, staticRenderFns } from "./AutosaveModal.vue?vue&type=template&id=2b3920c2&scoped=true"
import script from "./AutosaveModal.vue?vue&type=script&lang=js"
export * from "./AutosaveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3920c2",
  null
  
)

export default component.exports